<template>
  <div class="video">
    <video
      x5-video-player-fullscreen="false"
      x5-video-orientation="portrait"
      x-webkit-airplay="true"
      x5-video-player-type="h5-page"
      webkit-playsinline
      playsinline="true"
      controls="controls"
      :preload="preload"
      :src="videoInfo.videoAddress"
      class="replyVideo"
      ref="videoPlugin"
      :data-index="num"
    ></video>
    <!-- 视频封面蒙层 -->
    <div class="mask" v-if="isFirstIn"></div>
    <!-- 封面图 begin -->
    <div class="videoPoster" v-if="isFirstIn" :style="{backgroundImage: 'url('+ videoInfo.videoPoster+')'}"></div>
      <!-- 播放按钮-->
    <div class="play_btn " v-if="isFirstIn" @click.stop="playVideo"></div>
      <!-- 非WIFI begin -->
    <div class="video_no_wifi" v-show="networkType === 2 && isShowNotWifi">
      <p>正在使用非WI-FI网络，播放将消耗流量</p>
      <span @click.stop="goOnPlay">继续播放</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MyVideo',
  props: {
    preload: {
      type: String,
      default: 'meta'
    },
    videoInfo: {
      type: Object,
      default() {
        return {
          id: 0,
          videoAddress: '', // 视频地址
          videoPoster: '',
          name: ''
        }
      }
    },
    // 视频唯一标识。统计等需要
    num: {
      type: String,
      default: '-1'
    },
    // 统计时长节点。min为单位
    pointTime: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    pointTimer() {
      return new Array(this.pointTime.length)
    }
  },
  watch: {
    'videoInfo.videoAddress'() {
      // console.log('----- watch')
      this.isFirstIn = true
      // this.videoDom.pause()
      this.hasSetPointTimer = false
      this.pointTimer.map(v => clearInterval(v))
    }
  },
  data() {
    return {
      isShowNotWifi: false, // 是否展示非wifi提醒模块
      networkType: 1, // 1 wifi 2 移动
      isFirstIn: true, // 是否第一次进入。展示蒙层，播放按钮
      hasSetPointTimer: false, // 是否设置时间节点计时器
      notWifiFlag: false,
      videoDom: null
    }
  },
  mounted() {
    // this.getNetWorkStatus()
    this.videoDom = this.$refs.videoPlugin
    this.videoDom.addEventListener('loadedmetadata', () => {
      // console.log('on loaded meta data... ...')
      if (!this.hasSetPointTimer) {
        this.setPointTimer()
      }
    })

    this.videoDom.addEventListener('play', () => {
      // console.log('on play... ...')
      // 开始播放时首页封面图隐藏
      this.isFirstIn = false
      document.querySelectorAll('video').forEach(v => {
        if (v !== this.videoDom) {
          v.pause()
        }
      })
      this.$xesLogger.clickMsg({
        params: {
          clickid: 3.2,
          videoNum: this.num,
          action: 'videoPlay',
          clickname: '视频播放'
        }
      })
    })
  },
  unmounted() {
    this.pointTimer.map(v => clearInterval(v))
  },
  methods: {
    setPointTimer() {
      this.hasSetPointTimer = true
      const duration = this.videoDom.duration
      this.pointTime.filter(v => v <= duration).map((v, i) => {
        // if (v <= duration) return
        this.pointTimer[i] = setInterval(() => {
          this.$xesLogger.clickMsg({
            params: {
              clickid: 3.4,
              action: 'pointTime',
              videoNum: this.num,
              point: v
            }
          })
          clearInterval(this.pointTimer[i])
          this.pointTimer[i] = null
        }, v * 1000)
      })
    },
    /**
     * @description: App获取网络状态
     */
    getNetWorkStatus() {
      if (window.xesApp) {
        this.networkType = window.xesApp.getNetWorkStatus()
        console.log('当前网络环境为', this.networkType)
      }
    },
    /**
     * 非wifi继续播放
     */
    goOnPlay() {
      this.isShowNotWifi = false
      this.notWifiFlag = true
      this.playVideo()
      this.$xesLogger.clickMsg({
        params: {
          clickid: 3.1,
          clicklevel: '1',
          videoNum: this.num,
          action: 'goOnPlay',
          clickname: '非wifi点击继续播放'
        }
      })
    },
    playVideo() {
      console.log('isShowNotWifi', this.networkType, !this.notWifiFlag)
      // 非WIFI展示流量提醒
      if (this.networkType === 2 && !this.notWifiFlag) {
        this.isShowNotWifi = true
        return false
      }
      const videoDom = this.$refs.videoPlugin
      // console.log('videoDom', videoDom, videoDom.paused)
      videoDom.play()
      this.$xesLogger.clickMsg({
        params: {
          clickid: 3.3,
          clicklevel: '1',
          videoNum: this.num,
          action: 'playVideo',
          clickname: '播放视频'
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .video {
    position: relative;
    margin: auto;
    font-size: 0;

    video {
      background-color: rgba(0, 0, 0, 0.7);
    }

    .replyVideo,
    .videoPoster,
    .mask,
    .video_no_wifi,
    .play_btn {
      width: 100%;
      height: 100%;
      margin: auto;
    }

    .mask,
    .videoPoster,
    .video_no_wifi,
    .play_btn {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .mask {
      z-index: 2;
      background: #000;
      opacity: 0.3;
    }

    .videoPoster {
      background-size: cover;
      background-repeat: no-repeat;
    }

    .video_no_wifi {
      z-index: 6;
      background: #212831;

      p {
        margin: 69px 0 12px 0;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #fff;
        text-shadow: 0 1px 6px rgba(111, 61, 5, 0.1);
      }

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        height: 32px;
        margin: 0 auto;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #fff;
        background: #eb002a;
        border-radius: 16px;
        box-shadow: 0 1px 6px 0 rgba(111, 61, 5, 0.1);
        text-shadow: 0 1px 6px rgba(111, 61, 5, 0.1);
      }
    }

    .play_btn {
      top: 0;
      z-index: 5;
      background-image: url('./assets/images/icon_play.png');
      background-position: center;
      background-size: 55px;
      background-repeat: no-repeat;
    }
  }

</style>
